import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';
import { ChoiceButton, ChoiceType } from 'components/choice-button';

export enum SleepHoursAnswers { LESS5 = '5-less-hours', FROM5TO6 = '5-6-hours', FROM7TO8 = '7-8-hours', MORE8 = '8-more-hours' }

export const SleepHours = () => {
    const { t } = useTranslation();
    const { pageConfiguration } = useContext(BaseContext);

    const saveAnswers = useSaveAnswers();

    const pageKey = LocalStorageKeys[RoutePath.SleepHours];

    const { pageValue, setPageValue }: any = useLocalStorage({
        key: pageKey,
        defaultValue: '',
    });

    const handleClick = (answer: ChoiceType) => {
        setPageValue(answer.key);
        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('sleep-hours-title'), value: t(answer.value) },
        });

        pageConfiguration.handleOnPageComplete(answer.key);
    };

    const answers: ChoiceType[] = [
        {
            key: SleepHoursAnswers.LESS5,
            value: t('sleep-hours-option-5-less-hours'),
        },
        {
            key: SleepHoursAnswers.FROM5TO6,
            value: t('sleep-hours-option-5-6-hours'),
        },
        {
            key: SleepHoursAnswers.FROM7TO8,
            value: t('sleep-hours-option-7-8-hours'),
        },
        {
            key: SleepHoursAnswers.MORE8,
            value: t('sleep-hours-option-8-more-hours'),
        },
    ];

    return (
        <>
            <Typography variant={TypographyVariants.h1}>
                {t('sleep-hours-title')}
            </Typography>

            {answers.map((v: ChoiceType) => (
                <ChoiceButton
                    key={v.key}
                    center={true}
                    selected={v.key === pageValue}
                    typographyText={v.value}
                    onClick={() => handleClick(v)}
                />
            ))}
        </>
    );
};
